<script setup lang="ts">
    import type { HTMLAttributes } from 'vue';

    defineOptions({
        inheritAttrs: false,
    });

    interface Props {
        className?: HTMLAttributes['class'];
    }

    defineProps<Props>();
</script>

<template>
    <svg
        viewBox="0 0 17 17"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        :class="className"
    >
        <path
            d="M16.0748 0.746094H8.13832C8.13832 0.746094 8.12931 0.746094 8.1233 0.746094C3.75118 0.746094 0.207836 4.30817 0.207836 8.70109C0.207836 10.8734 1.07265 12.8402 2.47798 14.2753L0.174805 16.6561H8.1203C8.1203 16.6561 8.1203 16.6561 8.1233 16.6561C12.4954 16.6561 16.0388 13.094 16.0388 8.70109C16.0388 6.53182 15.174 4.56498 13.7716 3.12685L16.0748 0.746094ZM8.1233 13.5079C5.48682 13.5079 3.33979 11.3507 3.33979 8.70109C3.33979 6.05144 5.48682 3.89426 8.1233 3.89426C10.7598 3.89426 12.9068 6.05144 12.9068 8.70109C12.9068 11.3507 10.7598 13.5079 8.1233 13.5079Z"
            fill="currentColor"
        />
    </svg>
</template>
